// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","name":"Card_name__vpWb5","count":"Card_count__Bqd2x","image":"Card_image__i5ULR","suffix":"Card_suffix__5b42A"};